import { 
  GET_CAMPAIGN_COMPLETED, 
  GET_CAMPAIGN_COMPLETED_DATA,
  GET_CAMPAIGN_COMPLETED_START, 
  GET_CAMPAIGN_COMPLETED_END,
  GET_CAMPAIGN_COMPLETED_WINNER,
  GET_CAMPAIGN_COMPLETED_WINNER_TRANSACTIONS,
  GET_CAMPAIGN_COMPLETED_HISTORY_TRANSACTIONS,
  GET_CAMPAIGN_WITH_STATUS,
  BLACKLIST_CREATE,
  BLACKLIST_DELETE
} from "./type";
import { validateToken, redirectToLogin } from '../../utils/auth/tokenValidation';

interface Action {
  type: string;
  payload?: any; 
  loading?: boolean;
}

type Dispatch = (action: Action) => void;


const API_URL = process.env.REACT_APP_API_URL


export const getCompletedCampaign = () => async (dispatch: Dispatch): Promise<void> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return;
  }
  
  try {
    dispatch({
      type: GET_CAMPAIGN_COMPLETED_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/campaign/getAllCompleted/0/2000`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    


    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: GET_CAMPAIGN_COMPLETED_DATA,
        payload: [{ res }], 
        loading: false,
      });
    } else {
      const res = await response.json();
      dispatch({
        type: GET_CAMPAIGN_COMPLETED_END,
        payload: [{ res }], 
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_CAMPAIGN_COMPLETED_END,
      payload: false,
      loading: false,
    });
    console.error(error);
  }
};




export const getCampaignsWithStatus = () => async (dispatch: Dispatch): Promise<void> => {
  if (!validateToken()) { redirectToLogin(); return; }
  try {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_START, payload: true, loading: true });
    const token = localStorage.getItem("loginToken");
    if (!token) throw new Error("Authorization token not found");
    const response = await fetch(`${API_URL}/campaign/getAllWithStatus/0/2000`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
      body: JSON.stringify(["APPROVED", "EXECUTED"]),
    });
    if (response.status === 200) {
      const res = await response.json();
      dispatch({ type: GET_CAMPAIGN_WITH_STATUS, payload: [{ res }], loading: false });
    } else {
      const res = await response.json();
      dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: [{ res }], loading: false });
    }
  } catch (error) {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: false, loading: false });
    console.error(error);
  }
};


export const getRanges = (campaignId: string): any => async (dispatch: Dispatch): Promise<any> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  
  try {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_START, loading: true });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/campaign-winners/getWinningRange/${campaignId}`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const res = await response.json();

    if (response.ok) {
      dispatch({ type: GET_CAMPAIGN_COMPLETED, payload: res, loading: false });
      return { success: true, ...res };
    } else {
      dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: res.message, loading: false });
      return { success: false, ...res };
    }
  } catch (error: any) {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};


interface TransactionResponse {
  success: boolean;
  message?: string;
  data?: any;
}


export const getTransaction = (campaignId: string,startRange:any, endRange:any ): any => async (dispatch: Dispatch): Promise<TransactionResponse> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  
  try {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_START, loading: true });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/campaign-winners/calculateWinner/${campaignId}/${startRange}/${endRange}`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const res = await response.json();

    if (response.ok) {
      dispatch({ type: GET_CAMPAIGN_COMPLETED_WINNER, payload: res, loading: false });
      return { success: true, data: res };
    } else {
      dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: res.message, loading: false });
      return { success: false, ...res };
    }
  } catch (error: any) {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};


interface AnnounceWinnerResponse {
  success: boolean;
  message?: string;
}

export const AnnounceWinner = (campaignData: any): any => async (dispatch: Dispatch): Promise<AnnounceWinnerResponse> => {
  console.log(campaignData, 'Create data');

  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }

  try {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_START, loading: true });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/campaign-winners/announceWinners`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(campaignData),
    });

    const res = await response.json();
    console.log(res, 'API response'); 

    if (res.message == 'ok' && res.statusCode === 200) {
      dispatch({ type: GET_CAMPAIGN_COMPLETED_DATA, payload: res, loading: false });
      return { success: true, message: "Winner announced successfully", ...res };
    } else {
      dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: res.message || "Unknown error", loading: false });
      return { success: false, message: res.message || "Unknown error" };
    }
  } catch (error: any) {
    console.error("Error in AnnounceWinner:", error);
    dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};




export const getWinnerTransaction = (campaignId: string,campaignWinnerId:any ): any => async (dispatch: Dispatch): Promise<any> => {
  console.log(campaignWinnerId,campaignId);
  
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  
  try {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_START, loading: true });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/campaign-winners/get-transactions/${campaignId}/${campaignWinnerId}`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const res = await response.json();

    if (response.ok) {
      dispatch({ type: GET_CAMPAIGN_COMPLETED_WINNER_TRANSACTIONS, payload: res, loading: false });
      return { success: true, ...res };
    } else {
      dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: res.message, loading: false });
      return { success: false, ...res };
    }
  } catch (error: any) {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};


interface HistoryResponse {
  success: boolean;
  message?: string;
}


export const blacklistCreate = (customerIdentifier: string, comments: string = ''): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  try {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_START, loading: true });
    const token = localStorage.getItem("loginToken");
    if (!token) throw new Error("Authorization token not found");

    const payload = {
      id: 0,
      customerIdentifier,
      comments,
      createdAt: new Date().toISOString(),
      createdBy: Number(localStorage.getItem("userId") || 0),
    };

    const response = await fetch(`${API_URL}/blacklist/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
    const res = await response.json();
    if (response.ok) {
      dispatch({ type: BLACKLIST_CREATE, payload: res, loading: false });
      return { success: true, ...res };
    } else {
      dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: res.message, loading: false });
      return { success: false, message: res.message };
    }
  } catch (error: any) {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};


export const blacklistDelete = (id: number): any => async (dispatch: Dispatch): Promise<any> => {
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  try {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_START, loading: true });
    const token = localStorage.getItem("loginToken");
    if (!token) throw new Error("Authorization token not found");

    const response = await fetch(`${API_URL}/blacklist/delete/${id}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    });
    const res = await response.json();
    if (response.ok) {
      dispatch({ type: BLACKLIST_DELETE, payload: res, loading: false });
      return { success: true, ...res };
    } else {
      dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: res.message, loading: false });
      return { success: false, message: res.message };
    }
  } catch (error: any) {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};


export const getHistoryTransaction = (campaignId: string ): any => async (dispatch: Dispatch): Promise<HistoryResponse> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return { success: false, message: "Authentication required" };
  }
  
  try {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_START, loading: true });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/campaign/getCampaignHistory/${campaignId}`, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const res = await response.json();

    if (response.ok) {
      dispatch({ type: GET_CAMPAIGN_COMPLETED_HISTORY_TRANSACTIONS, payload: res, loading: false });
      return { success: true, ...res };
    } else {
      dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: res.message, loading: false });
      return { success: false, ...res };
    }
  } catch (error: any) {
    dispatch({ type: GET_CAMPAIGN_COMPLETED_END, payload: error.message, loading: false });
    return { success: false, message: error.message };
  }
};


